import {
  createCurrencyDictionaryItem,
  MockCurrencyDictionaryItem,
} from '@dapi/sdk/spec';

export const currencyCode = 'EUR';
export const currency: MockCurrencyDictionaryItem = createCurrencyDictionaryItem();

export const sekCurrency: MockCurrencyDictionaryItem = createCurrencyDictionaryItem({
  template: {
    name: 'SWEDISH KRONA',
    decimalPlaces: 0
  }
});

export const myRinggitCurrency: MockCurrencyDictionaryItem = createCurrencyDictionaryItem({
  template: {
    name: 'MY RINGGIT',
    decimalPlaces: 2
  }
});

export const inrCurrency: MockCurrencyDictionaryItem = createCurrencyDictionaryItem({
  template: {
    name: 'INDIAN RUPEE',
    decimalPlaces: 0
  }
});
